/* a24-info-modal.js
   Verhalten fuer snippets/a24-info-modal.liquid.

   Aufgabe 1 - Portal: Die Dialoge werden serverseitig in einem
   <template> ausgeliefert, weil sie sonst im Produktformular
   verschachtelt waeren und ein enthaltenes <form> vom HTML-Parser
   verworfen wuerde. Beim Laden haengen wir den Inhalt an <body>.

   Aufgabe 2 - Oeffnen, Wechseln, Schliessen per Event-Delegation.

   Aufgabe 3 - Nach dem Absenden eines Formulars im Modal laedt
   Shopify die Seite neu. Damit der Kunde die Bestaetigung sieht,
   merken wir uns das Modal und oeffnen es danach wieder. Beim
   Absenden wird ausserdem der Produktlink auf die aktuell im
   Browser stehende Adresse gesetzt - nur die enthaelt die gerade
   gewaehlte Variante.

   Mehrfaches Einbinden ist unschaedlich (Guard unten). */

(function () {
  if (window.a24InfoModalReady) return;
  window.a24InfoModalReady = true;

  var REOPEN_KEY = 'a24ReopenModal';

  /* Dialoge aus ihren <template>-Huellen nach <body> holen. Idempotent:
     ist die ID schon da, wird nur die Huelle aufgeraeumt. */
  function portalize() {
    var templates = document.querySelectorAll('template[data-a24-modal-portal]');

    Array.prototype.forEach.call(templates, function (tpl) {
      var id = tpl.getAttribute('data-a24-modal-portal');

      if (id && !document.getElementById(id)) {
        document.body.appendChild(tpl.content.cloneNode(true));
      }

      if (tpl.parentNode) tpl.parentNode.removeChild(tpl);
    });
  }

  function dialogById(id) {
    var dialog = document.getElementById(id);

    /* Noch nicht umgehaengt? Dann jetzt - deckt Sections ab, die erst
       nach dem ersten Lauf nachgeladen wurden. */
    if (!dialog) {
      portalize();
      dialog = document.getElementById(id);
    }

    return dialog;
  }

  /* Gibt dem Beratungsformular mit, aus welchem Info-Modal der Kunde
     kommt: verstecktes Feld contact[Thema] plus Vorbelegung der
     Textarea, solange dort nichts getippt wurde. */
  function passTopic(dialog, topic) {
    if (!topic) return;

    var form = dialog.querySelector('form');
    if (!form) return;

    var hidden = form.querySelector('[data-a24-topic]');
    if (hidden) hidden.value = topic;

    var note = form.querySelector('textarea[name="contact[body]"]');
    if (note && !note.value) note.value = 'Meine Frage betrifft: ' + topic;
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-a24-modal-open]');

    if (opener) {
      var dialog = dialogById(opener.getAttribute('data-a24-modal-open'));

      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }

      return;
    }

    /* "Beratung anfragen" im Info-Modal: Info-Modal schliessen und
       dasselbe Beratungs-Modal oeffnen wie der schwarze Button in der
       Buy Box. Fehlt es auf der Seite, greift der mailto-href. */
    var switcher = event.target.closest('[data-a24-modal-switch]');

    if (switcher) {
      var nextDialog = dialogById(switcher.getAttribute('data-a24-modal-switch'));

      if (nextDialog && typeof nextDialog.showModal === 'function') {
        event.preventDefault();

        var currentDialog = switcher.closest('dialog');
        if (currentDialog && currentDialog.open) currentDialog.close();

        passTopic(nextDialog, switcher.getAttribute('data-a24-modal-topic'));

        /* Erst im naechsten Frame oeffnen: sonst kollidiert showModal()
           mit dem gerade geschlossenen Dialog im Top-Layer (Safari). */
        window.requestAnimationFrame(function () {
          if (!nextDialog.open) nextDialog.showModal();
        });
      }

      return;
    }

    var closer = event.target.closest('[data-a24-modal-close]');

    if (closer) {
      var openDialog = closer.closest('dialog');

      if (openDialog) {
        event.preventDefault();
        openDialog.close();
      }
    }
  });

  /* Klick auf den Backdrop schliesst das Modal. */
  document.addEventListener('click', function (event) {
    if (!event.target.matches('dialog.a24-info-modal')) return;

    var box = event.target.getBoundingClientRect();
    var inside =
      event.clientX >= box.left &&
      event.clientX <= box.right &&
      event.clientY >= box.top &&
      event.clientY <= box.bottom;

    if (!inside) event.target.close();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.closest !== 'function') return;

    var dialog = form.closest('dialog.a24-info-modal');
    if (!dialog || !dialog.id) return;

    /* Der serverseitig gerenderte Link kennt die Variante vom
       Seitenaufbau. Die Adresszeile kennt die aktuelle. */
    var link = form.querySelector('[data-a24-pagelink]');
    if (link) link.value = window.location.href;

    try {
      window.sessionStorage.setItem(REOPEN_KEY, dialog.id);
    } catch (error) {
      /* Privater Modus o.ae.: dann eben ohne Wiederoeffnen. */
    }
  });

  function reopenAfterSubmit() {
    var id = null;

    try {
      id = window.sessionStorage.getItem(REOPEN_KEY);
      if (id) window.sessionStorage.removeItem(REOPEN_KEY);
    } catch (error) {
      return;
    }

    if (!id) return;

    var dialog = document.getElementById(id);
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
    }
  }

  /* Theme-Editor: nach dem Neuladen einer Section liefert der Server
     frische Huellen. Den alten Dialog wegwerfen, sonst zeigt das Modal
     veraltete Inhalte und die Huellen sammeln sich an. */
  document.addEventListener('shopify:section:load', function () {
    var templates = document.querySelectorAll('template[data-a24-modal-portal]');

    Array.prototype.forEach.call(templates, function (tpl) {
      var id = tpl.getAttribute('data-a24-modal-portal');
      var stale = id ? document.getElementById(id) : null;

      if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
    });

    portalize();
  });

  function boot() {
    portalize();
    reopenAfterSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
